module.exports = __webpack_public_path__ + "img/头图.b5869a0c.png";